export const getTokenLogoURL = (address?: string, tokenList?: any) => {
  if (!address) return undefined

  const logoExtensions = ['.png']

  // First try to get logo from tokenList if available
  const tokenListLogo = tokenList?.[address]?.tokenInfo?.logoURI

  // Then try local assets in the public folder
  const localLogos = logoExtensions
    .map((ext) => {
      try {
        // Use a path relative to the public folder (e.g., /static/assets/tokenLogo/)
        const publicPath = `/${address.toLowerCase()}${ext}`
        return publicPath // Return the URL path (e.g., /static/assets/tokenLogo/0x....png)
      } catch (e) {
        console.error('Error constructing logo path:', e)
        return null
      }
    })
    .filter(Boolean)

  // Combine both sources, putting tokenList logo first if it exists
  return [...(tokenListLogo ? [tokenListLogo] : []), ...localLogos]
}
